export const DEPOSIT = 50;
export const CASHBACK_LIMIT = 3;
